var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 34,
    viewBox: "0 0 84 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "title-bars"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 949",
    x: 9,
    width: 62,
    height: 8,
    rx: 4,
    fill: "url(#paint0_linear_87_1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 950",
    x: 22,
    y: 13,
    width: 62,
    height: 8,
    rx: 4,
    fill: "url(#paint1_linear_87_1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 951",
    y: 26,
    width: 62,
    height: 8,
    rx: 4,
    fill: "url(#paint2_linear_87_1620)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_1620",
    x1: 9,
    y1: -0.866242,
    x2: 10.8087,
    y2: 15.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352498,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553998,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_1620",
    x1: 22,
    y1: 12.1338,
    x2: 23.8087,
    y2: 28.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352498,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553998,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_1620",
    x1: -0.00000273025,
    y1: 25.1338,
    x2: 1.80872,
    y2: 41.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352498,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553998,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBars);
export default __webpack_public_path__ + "static/media/title-bars.518df41255efe39f6d76bd911e2543c3.svg";
export { ForwardRef as ReactComponent };